export const socketUrl = "https://virtualserver.pagfacil.inf.br/hubs/espelho";